import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ArrowGraphics } from '../Menu/ArrowGraphics';
import { sanitize } from '../../utils';
const AccordionButtonGraphics = ({ details, idx, onHover, children, }) => {
    const [hover, setHover] = useState(false);
    const onMouseMove = () => {
        if (!hover) {
            setHover(true);
            if (idx !== undefined && onHover) {
                onHover(idx, true);
            }
        }
    };
    const onMouseLeave = () => {
        if (hover) {
            setHover(false);
            if (idx !== undefined && onHover) {
                onHover(idx, false);
            }
        }
    };
    return (_jsxs("div", { className: `accordion-button-graphics${hover ? ' hover' : ''}`, onMouseEnter: onMouseMove, onMouseLeave: onMouseLeave, children: [_jsx(ArrowGraphics, { className: "accordion-button-arrow" }), _jsxs("div", { className: "accordion-button-graphics-text", children: [children, details ? (_jsx("span", { className: "accordion-button-graphics-details", dangerouslySetInnerHTML: {
                            __html: sanitize(details),
                        } })) : null] })] }));
};
export default AccordionButtonGraphics;
